// SCREENINGS Store
import store from ".."

const state = {
  STATUS: null,
  //API_ROUTE: '/reports-generated',
  API_ROUTE: "/reader-reports/" + sessionStorage.getItem("userID"),
  kioskID: "",
  reports: [],
  htmlFiles: {
    css_signedUrl: "",
    jpg_signedUrl: "",
    logo_signedUrl: ""
  }
}

const getters = {
  reports: (state) => {
    return state.reports
  },
  htmlFiles: (state) => {
    return state.htmlFiles
  }
}

// Called from Action to change State
const mutations = {
  getReports(state, reports) {
    state.reports = reports
  },
  updateHtmlFiles(state, files) {
    state.htmlFiles = files
  }
}

// Called externally to commit a State Mutation
const actions = {
  async loadReports({ commit }, payload) {
    const url = process.env.VUE_APP_URL + state.API_ROUTE
    const config = {
      headers: {
        "Content-Type": "application/json"
        //'Access-Control-Allow-Origin': '*',
      }
    }
    const data = null
    state.kioskID = payload

    await window.axios
      .get(url, data, config)
      .then((r) => r.data)
      .then((reports) => {
        commit("getReports", reports)
      })
      .catch(function (error) {
        state.STATUS = "An error occurred: " + error
      })
  },
  async defineReportHtmlFiles({ commit }) {
    const url = process.env.VUE_APP_URL + "/html-files"
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    }
    try {
      const response = await window.axios.get(url, config)
      //       {
      //     "css_signedUrl": "https://globecheckprod.blob.core.windows.net/globechek-files/rptAssets/css/reportPDFNEW.css?se=2025-04-29T00%3A53%3A24Z&sp=r&sv=2025-01-05&sr=b&sig=/kdyP0hopH1k9sBACvCffaEr9hu5ChiwmeWJCqJtt8M%3D",
      //     "jpg_signedUrl": "https://globecheckprod.blob.core.windows.net/globechek-files/rptAssets/img/imageNA.jpg?se=2025-04-29T00%3A53%3A24Z&sp=r&sv=2025-01-05&sr=b&sig=7V1M%2Bz4JYHDr4V30Fp5Uk1oaRlXGd7v2f6a7pme2HhY%3D"
      // }
      const files = response.data
      commit("updateHtmlFiles", files)
    } catch (error) {
      console.error("Error fetching HTML files:", error)
      state.STATUS = "An error occurred: " + error
    }
  },
  async generateHtmlBlob({ commit }, { isRxReport = false } = {}) {
    // If the css_signedUrl and jpg_signedUrl are empty, call defineReportHtmlFiles to fetch them
    try {
      if (
        state.htmlFiles.css_signedUrl === "" ||
        state.htmlFiles.jpg_signedUrl === "" ||
        state.htmlFiles.logo_signedUrl === ""
      ) {
        await actions.defineReportHtmlFiles({ commit })
      }

      // define the image that should be replaced
      const imgNA_pre = "/img/imageNA.77dc4548.jpg"
      // define the image that will replace it
      const imgNA_pdf = state.htmlFiles.jpg_signedUrl

      const imgLogo_pre = "/img/GlobeChek2.8abd2ad6.png"
      const imgLogo_pdf = state.htmlFiles.logo_signedUrl
      console.log("state.htmlfiles", state.htmlFiles)

      // define html css that will be used in the report
      const top = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><link href="${state.htmlFiles.css_signedUrl}"rel="stylesheet" type="text/css"  /><style>#gclogo {
        max-width: 200px; /* adjust as needed */
        height: auto;
        display: block;
        margin: auto;
      }
    </style></head><body>`
      const bottom = `<br></body></html>`

      // previously existing rule, need more investigation in the future
      const isRxDispensed = sessionStorage.getItem("rxDispensed") == "true" || sessionStorage.getItem("contactRxDispensed") == "true" ? true : false

      // define content
      let reportHTML_pre = ""
      if (isRxDispensed && !isRxReport) {
        reportHTML_pre = top + document.querySelector("#dispense-report").innerHTML + bottom
      } else {
        reportHTML_pre = top + document.querySelector("#pdf").innerHTML + bottom
      }

      // replace the image in the report
      const reportHTML = reportHTML_pre.replaceAll(imgNA_pre, imgNA_pdf).replaceAll(imgLogo_pre, imgLogo_pdf)

      // generate blob for download - used if testMode is true
      const metaData = new File([reportHTML], "../rptFile.html", {
        type: "text/html"
      })
      const blob = new Blob([metaData], { type: "text/html" })
      return { reportHTML, blob }
    } catch (error) {
      console.error("Error generating HTML blob:", error)
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async generateHtmlReport({ commit }, { isRxReport = false } = {}) {
    try {
      const { reportHTML, blob } = await actions.generateHtmlBlob({ commit }, { isRxReport })
      const testMode = false
      if (testMode) {
        //-START Browser DOWNLOAD FILE
        const e = document.createEvent("MouseEvents"),
          a = document.createElement("a")
        a.download = "report.html"
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl = ["text/html", a.download, a.href].join(":")
        e.initEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
        //-END Browser DOWNLOAD FILE
      }

      const url = process.env.VUE_APP_URL + "/report-html"
      let id = sessionStorage.getItem("storageID")
      if (isRxReport) id = `${id}-rx`
      const data = {
        Id: id,
        reportHtml: reportHTML
      }
      const response = await window.axios.post(url, data, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      return response
    } catch (error) {
      console.error("Error generating HTML report:", error)
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async generatePdfReport({ commit }, payload) {
    try {
      const reportId = payload.reportId
      const postPayload = {}
      if (payload.email && payload.firstName) {
        postPayload.email = payload.email
        postPayload.firstName = payload.firstName
      }
      const url = `${process.env.VUE_APP_URL}/pdf-report/${reportId}`
      const response = await window.axios.post(url, postPayload, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      return response
    } catch (error) {
      console.error("Error generating PDF report:", error)
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async getSignedReport({ commit }, payload) {
    const reportId = payload.reportId
    const url = `${process.env.VUE_APP_URL}/pdf/${reportId}`
    try {
      const response = await window.axios.get(url, { headers: { "Content-Type": "application/json" } })

      return response.data
    } catch (error) {
      console.error("Error fetching signed report:", error)
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
